import { BuyerNote, DeliveryInstructions, DeliverySafePlace, IossNumber } from '../../lib/consts/ItemMetaConstants';

const SmartSendCsvFieldMap = [
  { fields: ['Customer First Name', 'first name', 'first_name'] },
  { fields: ['Customer Surname', 'last name', 'last_name', 'surname'] },
  {
    fields: [
      'Customer Name',
      'customer',
      'name',
      'deliveryname',
      'recipient',
      'recipientname',
      'to',
      'buyer-name',
      'buyer name',
      'post to name'
    ]
  },
  {
    fields: [
      'Customer Property',
      'property',
      'deliveryproperty',
      'delproperty',
      'address1',
      'ship-address-1',
      'address_line_1',
      'address line 1',
      'post to address 1'
    ]
  },
  {
    fields: [
      'Customer Street',
      'street',
      'deliverystreet',
      'delstreet',
      'ship-address-2',
      'address_line_2',
      'post to address 2'
    ]
  },
  {
    fields: [
      'Customer Locality',
      'locality',
      'deliverylocality',
      'dellocality',
      'address2',
      'ship-address-3',
      'address_line_3',
      'address line 2/district/neighbourhood'
    ]
  },
  {
    fields: [
      'Customer Town',
      'town',
      'deliverytown',
      'deltown',
      'ship-city',
      'address_line_4',
      'post to city',
      'town/city'
    ]
  },
  { fields: ['Customer Postcode', 'postcode', 'deliverypostcode', 'delpostcode', 'ship-postal-code'] },
  {
    fields: [
      'Customer Phone',
      'telephone',
      'deliverytelephone',
      'tel',
      'mobile',
      'cellphone',
      'deltelephone',
      'delivery_phone',
      'post to phone',
      'contact phone number'
    ]
  },
  {
    fields: ['Customer Email', 'email', 'deliveryemail', 'delemail', 'buyer email', 'post to email']
  },
  { fields: ['Customer Country Code', 'country', 'country code', 'deliverycountry', 'delcountry', 'ship-country'] },
  { fields: ['Customer County', 'county', 'deliverycounty', 'delcounty', 'ship-state'] },
  { fields: ['Customer Organisation', 'organisation', 'company'] },
  { fields: ['Customer VAT Number', 'vatnumber'] },
  { fields: ['Customer EORI Number', 'eori', 'eorinumber', 'eori_number'] },
  { fields: ['Sender EORI Number', 'sender-eori'] },
  { fields: ['Sender VAT Number', 'sender-vatnumber'] },
  {
    fields: [
      'Account Id',
      'account',
      'account-name',
      'userid',
      'user id',
      'user-id',
      'buyer-id',
      'buyerid',
      'buyer username'
    ]
  },
  { fields: ['Item Height', 'height', 'itemheight', 'ht', 'h'] },
  { fields: ['Item Length', 'length', 'lg', 'l', 'lgth'] },
  { fields: ['Item Width', 'width', 'w'] },
  { fields: ['Item Weight', 'weight', 'kg', 'lb', 'wght', 'weight(kg)'] },
  { fields: ['Item Quantity', 'quantity', 'qty', 'items', 'quantity-purchased'] },
  {
    fields: ['Item Name', 'item name', 'item-name', 'description', 'product-name', 'contents', 'item title', 'subject']
  },
  { fields: ['Item Value', 'value', 'cost', 'gross', 'price', 'item-price', 'parcel_value', 'parcel_value(�)'] },
  {
    fields: ['Order Reference', 'reference', 'itemreference', 'ref', 'itemref', 'id', 'order-item-id', 'order number']
  },
  {
    fields: [
      'Order Sold Date',
      'transactionprocessed',
      'date',
      'downloaded date',
      'sold date',
      'paid on date',
      'sale date',
      'sold',
      'paid',
      'purchase-date'
    ]
  },
  { fields: ['Order IOSS Number', IossNumber.toLowerCase(), 'ioss', 'iossnumber'] },
  { fields: ['Order Note', BuyerNote.toLowerCase(), 'buyer note', 'buyer_note'] },
  { fields: ['Order Tags', 'tags'] },
  { fields: ['Order Service Id', 'service', 'service_id', 'serviceid'] },
  { fields: ['Label Reference', 'labelreference'] },
  { fields: ['Product Tariff Code', 'tariffcode', 'hscode', 'customscode'] },
  { fields: ['Product Country of Manufacture', 'countryofmanufacture', 'productorigin', 'origincountry'] },
  { fields: ['Product Export Reason', 'exportreason', 'purposeforexport'] },
  { fields: ['Product Sku', 'sku'] },
  { fields: ['Include Signature', 'signature', 'signature(y/n)'] },
  { fields: ['Include Parcel Cover', 'cover', 'compensation', 'compensation(�)'] },
  { fields: ['Include Print in Store', 'pis', 'print in store'] },
  { fields: ['Include Delivery Guarantee', 'deliveryguarantee', 'delivery guarantee'] },
  { fields: ['Include Delivery Duty Paid', 'delivereddutypaid', 'delivered duty paid', 'ddp'] },
  { fields: ['Is Amazon Prime', 'prime'] },
  { fields: ['Is GSP', 'global shipping programme', 'gsp'] },
  {
    fields: [
      'Delivery Safe Place',
      DeliverySafePlace.toLowerCase(),
      'safe place',
      'delivery_safe_place',
      'delivery safe place',
      'safe_place'
    ]
  },
  {
    fields: [
      'Delivery Instructions',
      DeliveryInstructions.toLowerCase(),
      'instructions',
      'delivery_instructions',
      'delivery instructions'
    ]
  }
];

export { SmartSendCsvFieldMap };
